import isFunction from 'lodash-es/isFunction';
import find from 'lodash-es/find';
import debug from './debug';

var requestQueue = [];
var currentRequest;

function dequeueRequest() {
  if (currentRequest) {
    return false;
  }

  currentRequest = requestQueue.shift();
  if (!currentRequest) {
    return false;
  }

  resolveWith(currentRequest.getPromise()).then(
    function(value) {
      currentRequest.resolve(value);
      currentRequest = null;
      dequeueRequest();
    },
    function(error) {
      currentRequest.reject(error);
      currentRequest = null;
      dequeueRequest();
    }
  );
}

function resolveWith(value) {
  if (value && isFunction(value.then)) {
    return value;
  }

  return Promise.resolve(value);
}

export default function addToRequestQueue(request) {
  const log = debug(`requestQueue:${request.name || request.hash}`);
  log('add', requestQueue.length);
  var dup = find(requestQueue, ['hash', request.hash]);
  if (dup) {
    log('duplicate', requestQueue.length);
    return dup.promise;
  }

  if (requestQueue.length > 500) {
    log('over 500 requests, skip', requestQueue.length);
    return Promise.resolve([]);
  }

  var res = new Promise(function(resolve, reject) {
    request.resolve = resolve;
    request.reject = reject;
    requestQueue.push(request);
    dequeueRequest();
  });
  request.promise = res;
  return res;
}
